import { render, staticRenderFns } from "./LanguageSwitch.vue?vue&type=template&id=047af9f8"
import script from "./LanguageSwitch.vue?vue&type=script&lang=ts"
export * from "./LanguageSwitch.vue?vue&type=script&lang=ts"
import style0 from "./LanguageSwitch.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/app/components/base/Icon/Icon.vue').default,Headline: require('/app/components/base/Headline/Headline.vue').default,Modal: require('/app/components/base/Modal/Modal.vue').default})
